import React from "react";
import { motion } from "framer-motion";
import { child, fadeIn } from "../../utils/motion";

const Data = () => {
  const text = ["P", "R", "V", "I", "N", " ", "A", "M", "A", "L", "A", "N"];
  return (
    <div className="home_data">
      <div className="d-flex align-items-center gap-4">
        <motion.div
          initial={{
            opacity: 0,
            transform: "translateX(-5vw) translateY(5vw)",
          }}
          whileInView={{
            opacity: 1,
            transform: "translateX(0vw) translateY(0vw)",
          }}
          transition={{ duration: 2.5, type: "spring" }}
        >
          <div className="d-flex flex-column align-items-center justify-content-center">
            <div className="circle"></div>
            <div className="line"></div>
          </div>
        </motion.div>
        <div className="home_details">
          <motion.h1
            initial={{
              opacity: 0,
              transform: "translateX(-10vw) translateY(-5vw)",
            }}
            whileInView={{
              opacity: 1,
              transform: "translateX(0vw) translateY(0vw)",
            }}
            transition={{ duration: 2.5, type: "spring" }}
          >
            Hi, I'm
          </motion.h1>
          <motion.div
            variants={fadeIn}
            initial="hidden"
            whileInView="visible"
            className="home_title"
          >
            {text.map((name, index) => (
              <motion.span
                key={index}
                variants={child}
                className=" font text-[#4dba87]"
              >
                {name === " " ? "\u00A0" : name}
              </motion.span>
            ))}
          </motion.div>
          <motion.div
            initial={{
              opacity: 0,
              transform: "translateX(10vw) translateY(5vw)",
            }}
            whileInView={{
              opacity: 1,
              transform: "translateX(0vw) translateY(0vw)",
            }}
            transition={{ duration: 2.5, type: "spring" }}
            className="font"
          >
            I am a Front End Developer,
            <br className="sm:block hidden" />
            based in chennai, and I'm very passionate and dedicated to my work
          </motion.div>
        </div>
      </div>
      <div className="home_button d-flex gap-2 mt-lg-4">
        <motion.div
          initial={{ opacity: 0, transform: "translateY(-8vw)" }}
          whileInView={{ opacity: 1, transform: "translateY(0vw)" }}
          transition={{
            duration: 2,
            type: "spring",
            stiffness: 150,
            damping: 15,
            delay: 1,
          }}
        >
          <motion.a
            initial={{ opacity: 1, y: 0 }}
            animate={{
              y: [0, 20, 0],
              scale: [1, 0.9, 1],
            }}
            transition={{
              duration: 3,
              repeat: Infinity,
              stiffness: 100,
              damping: 12,
              repeatType: "reverse",
            }}
            href="#contact"
            className="button button--flex text-decoration-none mt-2 mt-lg-0 fs-6"
          >
            Say Hello
            <svg
              class="button_icon"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M14.2199 21.9352C13.0399 21.9352 11.3699 21.1052 10.0499 17.1352L9.32988 14.9752L7.16988 14.2552C3.20988 12.9352 2.37988 11.2652 2.37988 10.0852C2.37988 8.91525 3.20988 7.23525 7.16988 5.90525L15.6599 3.07525C17.7799 2.36525 19.5499 2.57525 20.6399 3.65525C21.7299 4.73525 21.9399 6.51525 21.2299 8.63525L18.3999 17.1252C17.0699 21.1052 15.3999 21.9352 14.2199 21.9352ZM7.63988 7.33525C4.85988 8.26525 3.86988 9.36525 3.86988 10.0852C3.86988 10.8052 4.85988 11.9052 7.63988 12.8252L10.1599 13.6652C10.3799 13.7352 10.5599 13.9152 10.6299 14.1352L11.4699 16.6552C12.3899 19.4352 13.4999 20.4252 14.2199 20.4252C14.9399 20.4252 16.0399 19.4352 16.9699 16.6552L19.7999 8.16525C20.3099 6.62525 20.2199 5.36525 19.5699 4.71525C18.9199 4.06525 17.6599 3.98525 16.1299 4.49525L7.63988 7.33525Z"
                fill="var(--container-color)"
              ></path>
              <path
                d="M10.11 14.7052C9.92005 14.7052 9.73005 14.6352 9.58005 14.4852C9.29005 14.1952 9.29005 13.7152 9.58005 13.4252L13.16 9.83518C13.45 9.54518 13.93 9.54518 14.22 9.83518C14.51 10.1252 14.51 10.6052 14.22 10.8952L10.64 14.4852C10.5 14.6352 10.3 14.7052 10.11 14.7052Z"
                fill="var(--container-color)"
              ></path>
            </svg>
          </motion.a>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, transform: "translateY(-8vw)" }}
          whileInView={{ opacity: 1, transform: "translateY(0vw)" }}
          transition={{
            duration: 2,
            type: "spring",
            stiffness: 150,
            damping: 15,
            delay: 1.5,
          }}
        >
          <motion.a
            initial={{ opacity: 1, y: 0 }}
            animate={{
              y: [0, 20, 0],
              scale: [1, 0.9, 1],
            }}
            transition={{
              duration: 3,
              repeat: Infinity,
              stiffness: 100,
              damping: 12,
              repeatType: "reverse",
            }}
            href="https://www.linkedin.com/in/pravin-amalan-720675193/"
            target="_blank"
            className="button font text-decoration-none"
          >
            Hire Me
          </motion.a>
        </motion.div>
      </div>
    </div>
  );
};

export default Data;
